import { render } from "./SensorManage.vue?vue&type=template&id=5f2fbbf3"
import script from "./SensorManage.vue?vue&type=script&lang=js"
export * from "./SensorManage.vue?vue&type=script&lang=js"

import exportComponent from "/home/brant/git/HeySensCloudWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__